import { Injectable } from '@angular/core';
import {
  aoFalharValidacaoTokenTerminal,
  ehRecusaDefinitivaDeTerminal,
  mensagemFalhaValidacaoTerminal
} from './decisao-autorizacao-terminal';

@Injectable({ providedIn: 'root' })
export class ServicoDecisaoAutorizacaoTerminal {
  ehRecusaDefinitiva(erro: unknown) {
    return ehRecusaDefinitivaDeTerminal(erro);
  }

  aoFalharValidacao(erro: unknown, limparToken: () => void) {
    aoFalharValidacaoTokenTerminal(erro, limparToken);
  }

  mensagemFalhaValidacao(erro: unknown) {
    return mensagemFalhaValidacaoTerminal(erro);
  }
}
